export default __webpack_public_path__ + "static/media/assessment-level-4.2096a6d8.svg";